export default __webpack_public_path__ + "static/media/trainprincipa.6718dc07.jpg";